/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetStageDefinitionDto } from './GetStageDefinitionDto';
import {
    GetStageDefinitionDtoFromJSON,
    GetStageDefinitionDtoFromJSONTyped,
    GetStageDefinitionDtoToJSON,
} from './GetStageDefinitionDto';

/**
 * 
 * @export
 * @interface GetStageHintDto
 */
export interface GetStageHintDto {
    /**
     * 
     * @type {string}
     * @memberof GetStageHintDto
     */
    id: string;
    /**
     * 
     * @type {GetStageDefinitionDto}
     * @memberof GetStageHintDto
     */
    stageDefinition: GetStageDefinitionDto;
    /**
     * 
     * @type {string}
     * @memberof GetStageHintDto
     */
    url: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetStageHintDto
     */
    descriptionPl: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetStageHintDto
     */
    descriptionEn: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetStageHintDto
     */
    deadline: GetStageHintDtoDeadlineEnum;
    /**
     * 
     * @type {number}
     * @memberof GetStageHintDto
     */
    order: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetStageHintDto
     */
    active: boolean;
}


/**
 * @export
 */
export const GetStageHintDtoDeadlineEnum = {
    SinceProjectCreation: 'SinceProjectCreation',
    LastMonthEnd: 'LastMonthEnd',
    FifteenthOfCurrentMonth: 'FifteenthOfCurrentMonth',
    CurrentMonthEnd: 'CurrentMonthEnd',
    FifteenthOfNextMonth: 'FifteenthOfNextMonth',
    NextMonthEnd: 'NextMonthEnd'
} as const;
export type GetStageHintDtoDeadlineEnum = typeof GetStageHintDtoDeadlineEnum[keyof typeof GetStageHintDtoDeadlineEnum];


/**
 * Check if a given object implements the GetStageHintDto interface.
 */
export function instanceOfGetStageHintDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "stageDefinition" in value;
    isInstance = isInstance && "url" in value;
    isInstance = isInstance && "descriptionPl" in value;
    isInstance = isInstance && "descriptionEn" in value;
    isInstance = isInstance && "deadline" in value;
    isInstance = isInstance && "order" in value;
    isInstance = isInstance && "active" in value;

    return isInstance;
}

export function GetStageHintDtoFromJSON(json: any): GetStageHintDto {
    return GetStageHintDtoFromJSONTyped(json, false);
}

export function GetStageHintDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetStageHintDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'stageDefinition': GetStageDefinitionDtoFromJSON(json['stageDefinition']),
        'url': json['url'],
        'descriptionPl': json['descriptionPl'],
        'descriptionEn': json['descriptionEn'],
        'deadline': json['deadline'],
        'order': json['order'],
        'active': json['active'],
    };
}

export function GetStageHintDtoToJSON(value?: GetStageHintDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'stageDefinition': GetStageDefinitionDtoToJSON(value.stageDefinition),
        'url': value.url,
        'descriptionPl': value.descriptionPl,
        'descriptionEn': value.descriptionEn,
        'deadline': value.deadline,
        'order': value.order,
        'active': value.active,
    };
}

